import type {EndpointDirectoryV3} from '@smart/endpoint-directory';
import type {PaymentConfigV1} from '@smart/payment-config-service';
import type {SalesChannel} from '@smart/types';
import type {ProductSearchModel} from '../../bff/product-search-model/create-product-search-model';

export interface FetchSearchModelOptions {
  readonly endpointDirectory: EndpointDirectoryV3;
  readonly marketId: string;
  readonly language: string;
  readonly query: string;
  readonly sortBy: string;
  readonly salesChannel: SalesChannel;
  readonly paymentConfig?: PaymentConfigV1;
  readonly currentPage?: number;
}

export async function fetchSearchModel(
  baseUrl: string = ``,
  options: FetchSearchModelOptions,
): Promise<ProductSearchModel> {
  const {
    endpointDirectory,
    marketId,
    language,
    query,
    sortBy,
    paymentConfig,
    salesChannel,
    currentPage = 0,
  } = options;
  const {envName, preview, rotatingVerifySecret} = endpointDirectory;

  const searchParams = new URLSearchParams({
    envName,
    preview: String(preview),
    marketId,
    language,
    query,
    sortBy,
    salesChannel,
    currentPage: currentPage?.toString(),
  });

  if (paymentConfig && paymentConfig?.mode !== `cash-buy`) {
    let params = paymentConfig.params ?? undefined;
    if (`leasingParams` in paymentConfig && !params)
      params = paymentConfig.leasingParams;

    if (params)
      Object.entries(params).forEach(([k, v]) =>
        searchParams.set(k, v.toString()),
      );
  }

  if (rotatingVerifySecret) {
    const {headerName, headerValue} = rotatingVerifySecret;

    searchParams.set(`rotatingVerifySecret`, `${headerName}:${headerValue}`);
  }

  const url = `${baseUrl}/bff/product-search-model?${searchParams.toString()}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw Error(`Could not fetch stock search`);
  }

  return response.json() as Promise<ProductSearchModel>;
}
